import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  FormGroup,
} from "reactstrap";
import { profileSchema } from "@helpers/validation-schema";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Link } from "react-router-dom";
import { EMAIL_MAXLENGTH } from "@constants/constants";
import { NAME_MAXLENGTH, STORAGE_KEY } from "../../../constants/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDate } from "../../../helpers/helpers";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";
import { editUser, getUser } from "../../users/services/user-service";
import OtpModel from "../../../components/custom-table/OtpModel";
import { ToastContainer, toast } from "react-toastify";
import { resetError, saveUserProfile } from "../../users/controller/user-slice";
import ImageFileUpload from "../../../components/custom-image/ImageFileUpload";
import ViewModal from "@components/custom-table/ViewModel";
// actions
const UserProfile = () => {
  const { pathname } = useLocation();
  const route = pathname.split("/")[2];
  const userId = pathname.split("/")[3];
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const user = JSON.parse(localStorage.getItem(STORAGE_KEY.USER));
  const {
    control,
    handleSubmit,
    setError,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(profileSchema),
  });
  const userProfile = useSelector((state) => state.user.users) || {};
  const [otpModel, setOtpModel] = useState(false);
  const successMessage = useSelector((state) => state.user.successMessage);
  const errorMessage = useSelector((state) => state.user.errorMessage);
  const [viewImageUrl, setViewImageUrl] = useState("");
  const [fileInfo, extractFileMetadata, additionalInfo, extractAdditionalData] =
    ImageFileUpload();
  const [viewModel, setViewModel] = useState(false);

  useEffect(() => {
    dispatch(getUser(route === "edit" ? userId : user?._id));
    dispatch(resetError());
  }, [dispatch]);

  useEffect(() => {
    if (successMessage !== null) {
      toast.success(successMessage);
      if (route !== "edit" || isUpdated) {
        setOtpModel(true);
        // dispatch(resetSuccess());
      }
    }
  }, [successMessage, isUpdated]);

  const formInitialized = useRef(false);

  useEffect(() => {
    if (user) {
      setValue("short_name", userProfile?.short_name);
      setValue("email", userProfile?.email);
      setValue("role_id", userProfile?.role?.name);
      setValue("country_id", userProfile?.country?.name);
      setValue("district_id", userProfile?.district?.name);
      setValue("state_id", userProfile?.state?.name);
      if (route === "edit") {
        setValue("full_name", userProfile?.full_name);
        setValue("gender", userProfile?.gender);
        setValue("address_line_1", userProfile?.address_line_1);
        setValue("address_line_2", userProfile?.address_line_2);
        setValue("id_type_name", userProfile?.id_type_name);
        setValue("mobile", userProfile?.mobile);
        setValue("postal_code", userProfile?.postal_code);
        setValue("date_of_birth", userProfile?.date_of_birth?.split("T")[0]);
      }
    }
  }, [user, setValue, route, userProfile]);

  // useEffect(() => {
  //   if (user) {
  //     setValue("short_name", userProfile?.short_name);
  //     setValue("email", userProfile?.email);
  //     setValue("role_id", userProfile?.role?.name);
  //     setValue("country_id", userProfile?.country?.name);
  //     setValue("district_id", userProfile?.district?.name);
  //     setValue("state_id", userProfile?.state?.name);
  //     if (route === "edit") {
  //       setValue("full_name", userProfile?.full_name);
  //       setValue("gender", userProfile?.gender);
  //       setValue("address_line_1", userProfile?.address_line_1);
  //       setValue("address_line_2", userProfile?.address_line_2);
  //       setValue("id_type_name", userProfile?.id_type_name);
  //       setValue("mobile", userProfile?.mobile);
  //       setValue("postal_code", userProfile?.postal_code);
  //       setValue("date_of_birth", userProfile?.date_of_birth?.split("T")[0]);
  //     }
  //   }
  // }, [user, setValue, route]);

  const handleProfileUpload = async (file) => {
    const fileExtension = {
      extensions: [file?.name.split(".").pop()?.toLowerCase()],
    };
    try {
      const response = await Client(
        API_METHOD.POST,
        url.presigned_url,
        fileExtension
      );
      const presignedUrl = response.data.data.items[0].preSignedUrl;

      const imageTemp = response.data.data.items[0].fileName;

      const saveImage = await fetch(presignedUrl, {
        method: "PUT",
        body: file,
        redirect: "follow",
      });
      if (saveImage.status === 200) {
        return { imageTemp };
      } else {
        return { type: "error", message: "Failed to Upload Image" };
      }
    } catch (error) {
      return { type: "error", message: "Failed to Upload Image" };
    }
  };

  const onSubmit = async (data) => {
    setIsLoading(true);

    let tempImageUrl = { aadharImage: "", profileImage: "" };

    try {
      if (data.aadhar_image) {
        const generatePresignedUrl = await handleProfileUpload(
          data.aadhar_image
        );
        if (generatePresignedUrl.imageTemp) {
          tempImageUrl.aadharImage = generatePresignedUrl.imageTemp;
        } else {
          throw new Error("Failed to upload Aadhar Image");
        }
      }

      if (data.profile_image) {
        const generatePresignedUrl = await handleProfileUpload(
          data.profile_image
        );
        if (generatePresignedUrl.imageTemp) {
          tempImageUrl.profileImage = generatePresignedUrl.imageTemp;
        } else {
          throw new Error("Failed to upload Profile Image");
        }
      }

      const { aadhar_image, profile_image, ...filteredData } = data;
      const formattedData = {
        ...filteredData,
        address_line_1: data.address_line_1,
        address_line_2: data.address_line_2,
        mobile: data.mobile,
        postal_code: data.postal_code,
        full_name: data.full_name,
        role_id: userProfile?.role?._id,
        country_id: userProfile?.country?._id,
        district_id: userProfile?.district?._id,
        state_id: userProfile?.state?._id,
        id_proof: tempImageUrl?.aadharImage
          ? {
              url: tempImageUrl.aadharImage,
              ...additionalInfo,
            }
          : userProfile?.id_proof,
        image: tempImageUrl?.profileImage
          ? {
              image_url: tempImageUrl.profileImage,
              ...fileInfo,
            }
          : userProfile?.image,
        _id: userProfile?._id,
      };


      if (data?.mobile !== userProfile?.mobile && route === "edit") {
        dispatch(saveUserProfile(formattedData));
        profileUpdateForm(formattedData, userProfile?._id);
        setOtpModel(true);
        setIsUpdated(true);
        return;
      }

      dispatch(saveUserProfile(formattedData));
      profileUpdateForm(formattedData, userProfile?._id);
    } catch (error) {
      // Handle errors
      console.error("Error in onSubmit:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (errorMessage !== null) {
      toast.error(errorMessage?.message);

      errorMessage.data.items.forEach((item) => {
        const fieldName = Object.keys(item)[0];
        const message = item[fieldName];
        setError(fieldName, { type: "manual", message });
      });
    }
  }, [errorMessage, setError]);

  const profileUpdateForm = (formattedData, profileId) => {
    dispatch(editUser({ id: profileId, data: formattedData }));
  };

  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() - 13);

  const handleViewImage = (imageUrl) => {
    setViewImageUrl(imageUrl);
    setViewModel(true);
  };
  return (
    <React.Fragment>
      <OtpModel show={otpModel} onCloseClick={() => setOtpModel(false)} />
      {viewModel && (
        <ViewModal
          show={viewModel}
          onViewClick={handleViewImage}
          onCloseClick={() => setViewModel(false)}
          data={viewImageUrl || ""}
        />
      )}
      <div className="page-content">
        <Container fluid className="">
          {/* Render Breadcrumb */}
          <ToastContainer autoClose={2000} />

          <h4 className="card-title mb-4 text-start">
            {route !== "edit" ? "Create Profile" : "Edit Profile"}
          </h4>

          <Card>
            <CardBody>
              <form onSubmit={handleSubmit(onSubmit)} className="text-start">
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="Name">Short Name</Label>
                      <Controller
                        name="short_name"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <div>
                            <Input
                              {...field}
                              placeholder="Enter name"
                              // value={country?.name??""}
                              readOnly
                              maxLength={NAME_MAXLENGTH}
                            />
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="Email">Email</Label>
                      <Controller
                        name="email"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <div>
                            <Input
                              {...field}
                              type="email"
                              placeholder="Enter your email"
                              readOnly
                              maxLength={EMAIL_MAXLENGTH}
                            />
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="Role">Role</Label>
                      <Controller
                        name="role_id"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <div>
                            <Input
                              {...field}
                              type="text"
                              readOnly
                              placeholder="Enter your role"
                            />
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="Country">Country</Label>
                      <Controller
                        name="country_id"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <div>
                            <Input
                              {...field}
                              type="text"
                              readOnly
                              placeholder="Enter your role"
                            />
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="State">State</Label>
                      <Controller
                        name="state_id"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <div>
                            <Input
                              {...field}
                              type="text"
                              placeholder="Enter your state"
                              readOnly
                            />
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="District">District</Label>
                      <Controller
                        name="district_id"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <div>
                            <Input
                              {...field}
                              type="text"
                              readOnly
                              placeholder="Enter your role"
                            />
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="Full Name"> Full Name</Label>
                      <Controller
                        name="full_name"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <div>
                            <Input
                              {...field}
                              placeholder="Enter Full Name"
                              invalid={!!errors.full_name}
                              // value={country?.name??""}
                              maxLength={NAME_MAXLENGTH}
                            />
                            {errors.full_name && (
                              <FormFeedback>
                                {errors.full_name.message}
                              </FormFeedback>
                            )}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <Controller
                      name="gender"
                      control={control}
                      render={({ field }) => (
                        <FormGroup>
                          <Label for="gender">Gender</Label>
                          <div style={{ display: "flex", gap: "10px" }}>
                            <div>
                              <Input
                                type="radio"
                                id="male"
                                name="gender"
                                value="male"
                                checked={field.value === "male"}
                                onChange={(e) => field.onChange(e.target.value)}
                              />
                              <Label for="male" style={{ marginLeft: "5px" }}>
                                Male
                              </Label>
                            </div>
                            <div>
                              <Input
                                type="radio"
                                id="female"
                                name="gender"
                                value="female"
                                checked={field.value === "female"}
                                onChange={(e) => field.onChange(e.target.value)}
                              />
                              <Label for="female" style={{ marginLeft: "5px" }}>
                                Female
                              </Label>
                            </div>
                            <div>
                              <Input
                                type="radio"
                                id="other"
                                name="gender"
                                value="other"
                                checked={field.value === "other"}
                                onChange={(e) => field.onChange(e.target.value)}
                              />
                              <Label for="other" style={{ marginLeft: "5px" }}>
                                Other
                              </Label>
                            </div>
                          </div>
                          {errors.gender && (
                            <FormFeedback className="d-block">
                              {errors.gender.message}
                            </FormFeedback>
                          )}
                        </FormGroup>
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="Address 1">Address 1</Label>
                      <Controller
                        name="address_line_1"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <div>
                            <Input
                              {...field}
                              placeholder="Enter Address"
                              invalid={!!errors.address_line_1}
                              // value={country?.name??""}
                              maxLength={NAME_MAXLENGTH}
                            />
                            {errors.address_line_1 && (
                              <FormFeedback>
                                {errors.address_line_1.message}
                              </FormFeedback>
                            )}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="Address 2">Address 2</Label>
                      <Controller
                        name="address_line_2"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <div>
                            <Input
                              {...field}
                              placeholder="Enter Address 2"
                              invalid={!!errors.address_line_2}
                              // value={country?.name??""}
                              maxLength={NAME_MAXLENGTH}
                            />
                            {errors.address_line_2 && (
                              <FormFeedback>
                                {errors.address_line_2.message}
                              </FormFeedback>
                            )}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="image">
                        {" "}
                        Profile Image
                        {route === "edit" ? (
                          <Link
                            className="ms-2"
                            onClick={() => {
                              handleViewImage(userProfile?.image?.image_url);
                            }}
                          >
                            View
                          </Link>
                        ) : null}
                      </Label>
                      <Controller
                        name="profile_image"
                        control={control}
                        defaultValue={null}
                        render={({ field }) => (
                          <div>
                            <Input
                              type="file"
                              accept="image/jpeg,image/png"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                field.onChange(file);
                                extractFileMetadata(file);
                              }}
                              invalid={!!errors.image}
                            />
                            {errors.image && (
                              <FormFeedback>
                                {errors.image.message}
                              </FormFeedback>
                            )}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="image">
                        {" "}
                        Id Proof
                        {route === "edit" ? (
                          <Link
                            className="ms-2"
                            onClick={() => {
                              handleViewImage(userProfile?.id_proof?.url);
                            }}
                          >
                            View
                          </Link>
                        ) : null}
                      </Label>
                      <Controller
                        name="aadhar_image"
                        control={control}
                        defaultValue={null}
                        render={({ field }) => (
                          <div>
                            <Input
                              type="file"
                              accept="image/jpeg,image/png"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                field.onChange(file);
                                extractAdditionalData(file);
                              }}
                              invalid={!!errors.id_proof}
                            />
                            {errors.id_proof && (
                              <FormFeedback>
                                {errors.id_proof.message}
                              </FormFeedback>
                            )}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="Postal Code">Postal Code</Label>
                      <Controller
                        name="postal_code"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <div>
                            <Input
                              {...field}
                              placeholder="Enter Postal Code"
                              invalid={!!errors.postal_code}
                              // value={country?.name??""}
                              maxLength={NAME_MAXLENGTH}
                            />
                            {errors.postal_code && (
                              <FormFeedback>
                                {errors.postal_code.message}
                              </FormFeedback>
                            )}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="Aadhar Id">Id Type</Label>
                      <Controller
                        name="id_type_name"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <div>
                            <Input
                              {...field}
                              placeholder="Enter Aadhar Id"
                              invalid={!!errors.id_type_name}
                              // value={country?.name??""}
                              maxLength={NAME_MAXLENGTH}
                            />
                            {errors.id_type_name && (
                              <FormFeedback>
                                {errors.id_type_name.message}
                              </FormFeedback>
                            )}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="Mobile No">Mobile No</Label>
                      <Controller
                        name="mobile"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <div>
                            <Input
                              {...field}
                              placeholder="Enter Mobile Number"
                              invalid={!!errors.mobile}
                              // value={country?.name??""}
                              maxLength={NAME_MAXLENGTH}
                            />
                            {errors.mobile && (
                              <FormFeedback>
                                {errors.mobile.message}
                              </FormFeedback>
                            )}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="Date of Birth">Date of Birth</Label>
                      <Controller
                        name="date_of_birth"
                        control={control}
                        defaultValue={null}
                        render={({ field }) => (
                          <div>
                            <DatePicker
                              selected={field.value}
                              onChange={(date) =>
                                field.onChange(formatDate(date))
                              }
                              placeholderText="Select Date of Birth"
                              maxDate={maxDate}
                              showYearDropdown
                              scrollableYearDropdown
                              isClearable
                              dateFormat="dd/MM/yyyy"
                              customInput={
                                <Input invalid={!!errors.date_of_birth} />
                              }
                              className="custom-datepicker"
                            />
                            {errors.date_of_birth && (
                              <FormFeedback>
                                {errors.date_of_birth.message}
                              </FormFeedback>
                            )}
                          </div>
                        )}
                      />
                    </FormGroup>

                    {/* <FormGroup>
                      <Label for="Date of Birth">Date of Birth</Label>
                      <Controller
                        name="date_of_birth"
                        control={control}
                        defaultValue={null}
                        render={({ field }) => (
                          <div>
                            <DatePicker
                              selected={field.value}
                              onChange={(date) =>
                                field.onChange(formatDate(date))
                              }
                              placeholderText="Select Date of Birth"
                              maxDate={maxDate}
                              showYearDropdown
                              scrollableYearDropdown
                              isClearable
                              dateFormat="dd/MM/yyyy"
                              customInput={
                                <Input invalid={!!errors.date_of_birth} />
                              }
                            />
                            {errors.date_of_birth && (
                              <FormFeedback>
                                {errors.date_of_birth.message}
                              </FormFeedback>
                            )}
                          </div>
                        )}
                      />
                    </FormGroup> */}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}></Col>
                  <Col md={6}>
                    <div className="d-flex justify-content-end gap-2">
                      {route !== "edit" ? (
                        <Button
                          type="submit"
                          className={isLoading ? "disabled" : ""}
                          color={isLoading ? "success" : "primary"}
                        >
                          {isLoading ? <>Loading...</> : <> Submit</>}
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          className={isLoading ? "disabled" : ""}
                          color={isLoading ? "success" : "primary"}
                        >
                          {isLoading ? <>Loading...</> : <> Update</>}
                        </Button>
                      )}
                    </div>
                  </Col>
                </Row>
              </form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserProfile;
